import { EventEmitter } from "@angular/core";
import { ExcelExportData } from "@progress/kendo-angular-excel-export";
import { GridDataResult } from "@progress/kendo-angular-grid";
import { State } from "@progress/kendo-data-query";
import { BehaviorSubject, Observable } from "rxjs";
import { IDashboardFilter } from "src/app/home/filter/filter.model";
import { ApiHttpService } from "src/app/services/api-http.service";

export abstract class AppGridServiceAbstract {
    public gridData: {[id: string]: BehaviorSubject<GridDataResult>} = {};
    protected _valueChanges: EventEmitter<any>;
    // Below are public properties for gridRawDataTotal and gridRawData with key-value mappings
    public gridRawDataTotal: { [key: string]: number }; // Add this line
    public gridRawData : { [key: string]: any }; // Add this line

    constructor(public _http: ApiHttpService) {
        this._valueChanges = new EventEmitter();
        this.gridRawDataTotal = {}; // Initialize the property
        this.gridRawData = {}; // Initialze the property
    }

    // Modified query method to include isDynamicAppGrid parameter to handle dynamic grid configuration.
    public abstract query(api: string, state: State, forceUpdate: boolean, filter: IDashboardFilter, queryData: boolean, algoId?: number,  isDynamicAppGrid?: boolean): any;

    public abstract getData(api: string): any[];

    deleteRowApi(api: string, id: number): Observable<Response> {
        return this._http.delete(api + `/${id}`);
    }

    public abstract deleteRowData(api: string, idField: string, id: any): void;

    public abstract getExcelData(api: string, state: State): ExcelExportData | Observable<ExcelExportData>;

    get valueChanges(): Observable<any> { return this._valueChanges; }

    public abstract setData(api: string, data: any[]): void;
}
